<template minapp="mpx" xlang="wxml">
  <es-layout
    custom-class
    leftArrow="{{true}}"
    layout="{{['header','footer']}}"
    custom-title="custom-title"
    navbarClickLeft="{{goBack}}"
    navbarTitle="{{navbarTitle}}"
    navbarStyle="{{navbarStyle}}"
  >
    <!-- 页面 footer 部分 -->
    <view slot="footer" class="footer" wx:style="padding-bottom: {{footerPaddingBottom}}">
      <es-button
        size="large"
        custom-class="left-button"
        bind:click="goHome"
        wx:style="flex:1;margin-right:4px"
        >返回首页
      </es-button>
      <es-button
        size="large"
        custom-class="right-button"
        bind:click="goOrderDetail(2)"
        wx:style="flex:1;margin-left:4px"
        >订单详情
      </es-button>
    </view>
    <!-- 页面主要内容 -->
    <view class="card-main">
      <view class="top">
        <!-- 主标题部分 -->
        <es-icon color="#1473FF" size="64" name="check-circle-filled" />
        <view class="order-status">{{ status }}</view>
        <view class="order-desc">{{ desc }}</view>
      </view>
      <!-- 订单卡片 -->
      <view bindtap="goOrderDetail(3)">
        <order-card wx:for="{{ticketsInfo}}" ticket="{{item}}" class="order-card" />
      </view>
      <!-- 优惠告知条 -->
      <card-frame wx:if="{{isShowCardFrame}}" class="card-frame" cardConf="{{couponInformBar}}" />
      <!-- content 为空不展示 -->
      <warm-tips title="温馨提示" content="{{content}}" from="success" />
    </view>
  </es-layout>
</template>

<script>
  import store from '@/store'
  import { trackEvent } from '@/common/track'
  import { bottomSafeArea, ORDERSTATUSINFO } from '@/common/constant'
  import { mpx, createPage } from '@didi/es-mpx-creator'
  import { getStorage, setStorage } from '@/utils/storage'
  import { innerRouter, pagePath } from '@/common/jump'
  import { STORAGE_SUCCESS_INFO, STORAGE_SELECT_TICKET } from '../utils/train-storage'
  import { getFinalPrice } from '@/utils/money'

  createPage({
    data: {
      desc: '',
      status: '',
      content: [],
      navbarTitle: '',
      payType: '',
      couponInformBar: {},
      footerPaddingBottom: bottomSafeArea(),
      navbarStyle: {
        color: '#000',
        background: '#fff',
        'font-size': '18px',
        'font-weight': 600,
        'font-family': 'PingFangSC-Semibold'
      },
      ticketsInfo: [],
    },
    computed: {
      ...store.mapState({
        orderList: 'order.order_list',
      }),
      // 是否展示 card-frame
      isShowCardFrame() {
        return this.couponInformBar?.title?.text
      },
      processingTicket() {
        let _processingTicket = []
        _processingTicket = this.orderList?.map((order) => {
          const { tickets_info } = order || {}
          const personal_pay = tickets_info?.reduce(
            (tot, cur) => (tot += +cur.personal_pay),
            0
          )
          let _passengerInfo = ''
          let _des = ''
          const ticketLength = tickets_info?.length ?? 0
          if (tickets_info && ticketLength > 0) {
            const passengerNames = tickets_info.slice(0, 3).map((ticket) => ticket.passenger_name)
            _passengerInfo = passengerNames.join('、')
            if (ticketLength > 3) {
              _des = `等${ticketLength}人`
            } else {
              _des = `共${ticketLength}人`
            }
          }
          const passenger_name = _passengerInfo + _des
          const { seat_type, coach_no, seat_name } = tickets_info?.[0] || {}
          const seat_info =
            ticketLength > 0 && coach_no
              ? `${seat_type} ${coach_no}车${seat_name}${ticketLength > 1 ? '...' : ''}`
              : ''
          return { ...order, personal_pay, passenger_name, seat_info}
        })
        return _processingTicket
      }
    },
    mounted() {
      this.initPage()
      this.swLog()
    },
    methods: {
      // 初始化页面
      initPage() {
        const successInfo = getStorage(STORAGE_SUCCESS_INFO)
        this.ticketsInfo = getStorage(STORAGE_SELECT_TICKET)?.ticket || this.processingTicket || []
        this.desc = successInfo?.desc ?? ''
        this.payType = successInfo?.payType ?? ''
        this.status = successInfo?.status ?? '提交成功'
        this.content = successInfo?.content ?? []
        this.navbarTitle = successInfo?.title ?? '提交成功'
        this.couponInformBar = {
          title: {
            icon: 'https://ut-static.udache.com/webx/sfc/8LWLwsBdPKWUbAVzKwETK.png',
            text: successInfo?.couponInformBar?.couponDesc,
            fontSize: '14px'
          }
        }
      },
      // 返回首页
      goHome() {
        this.ckBtnLog(1)
        innerRouter.replace(pagePath().HOME)
      },
      // 返回首页
      goBack() {
        this.ckBackLog()
        innerRouter.replace(pagePath().HOME)
      },
      // 跳转详情页
      goOrderDetail(type) {
        const { from = '', order_id = '' } = this.$mpxRoute.query
        this.ckBtnLog(type)
        innerRouter.mpReplace(pagePath().ORDERDETAIL, { from: 'home', order_id })
      },
      // 埋点公共函数
      commonLog(key = '', name = '', params = {}) {
        const navbarTitleKey = Object.keys(ORDERSTATUSINFO).find(
          (key) => ORDERSTATUSINFO[key].title === this.navbarTitle
        )
        trackEvent(key, name, {
          order_id: this.$mpxRoute?.query?.order_id,
          status: this.payType || navbarTitleKey,
          desc: this.status,
          ...params
        })
      },
      // 曝光埋点
      swLog() {
        this.commonLog('userteam_train_subresult_sw', 'UT-火车票-提交结果-曝光')
      },
      // 点击左上角返回
      ckBackLog() {
        this.commonLog('userteam_train_subresult_return_ck', 'UT-火车票-提交结果-返回-点击')
      },
      // 点击页面按钮埋点
      ckBtnLog(type) {
        this.commonLog('userteam_train_subresult_module_ck', 'UT-火车票-订单详情-支付成功页-点击', {
          module: type
        })
      }
    }
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .custom-title
    font-size 18px
    font-family PingFangSC
  .card-main
    display flex
    flex-direction column
    background white
    padding 12px 12px 60px
    height 100%
    .card-frame
      border-radius 8px
      background #FFF6F1
      border 1.5px solid #fff
      margin-top 10px
    .top
      margin-top 28px
      margin-bottom 68px
      display flex
      flex-direction column
      background white
      align-items center
      .order-status
        text-align center
        margin-top 16px
        font-size 18px
        font-weight 500
        font-family PingFangSC
        color black
      .order-desc
        margin-top 7px
        font-size 13px
        color $train-color-666
  .footer
    background white
    height 88px
    padding 0px 12px
    position fixed
    left 0
    right 0
    bottom 0
    display flex
    justify-content space-around
    align-items center
    box-shadow 0 -4px 10px RGBA(0, 0, 0, 0.04)
    font-size 12px
    color $train-color-333
    .right-button
      font-size 16px
      font-weight 600
      height 48px
      text-align center
      color white
      border-width 0px
      border-radius 8px
      background-color $train-color-theme-blue
    .left-button
      font-size 16px
      font-weight 600
      height 48px
      color $train-color-theme-blue
      box-sizing border-box
      text-align center
      font-family PingFangSC
      border 1px solid $train-color-theme-blue
      border-radius 8px
  .order-card
    &:not(:first-child)
      margin-top 12px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'card-frame': '@/components/card-frame',
      'warm-tips': '@/components/warm-tips',
      'order-card': '@/components/order-card'
    }
  }
</script>